import * as React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {flex, flexDirection, mr} from "@pg-design/helpers-css";
import {CityIcon, MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text, TextVariantUnionType} from "@pg-design/text-module";

import {getPropertyDistance, getPropertyLocation} from "../../helpers/quick_view/set_property_info";

interface IProps {
    address: string;
    offerType: number;
    distanceFromRegion?: {
        center: boolean;
        region: string;
        distance: number;
    };
    className?: string;
    textVariant?: TextVariantUnionType;
}

export const QWLocalizationInfo = (props: IProps) => {
    const {offerType, address, distanceFromRegion} = props;

    const theme = useTheme();
    return (
        <div css={localizationInfo} className={props.className}>
            <div css={flex("flex-start")}>
                <MapMarkerOutlineIcon css={mr(1)} size="2.4" fill={theme.colors.gray[700]} />

                <Text as="div" variant={props.textVariant || "info_txt_2"} mb="1.6rem">
                    <span>{getPropertyLocation(offerType, address)}</span>
                </Text>
            </div>
            {distanceFromRegion && (
                <div css={flex("flex-start")}>
                    <CityIcon css={mr(2)} size="2.4" fill={theme.colors.gray[700]} />

                    <Text as="div" variant={props.textVariant || "info_txt_2"} mb="1.6rem">
                        <span>{getPropertyDistance(distanceFromRegion)}</span>
                    </Text>
                </div>
            )}
        </div>
    );
};
const localizationInfo = (theme: Theme) => css`
    color: ${theme.colors.gray[700]};
    padding-left: 0.6rem;
    ${flex("flex-start")};
    ${flexDirection("column")};
`;
import * as React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {flex, flexDirection, mr} from "@pg-design/helpers-css";
import {CityIcon, MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text, TextVariantUnionType} from "@pg-design/text-module";

import {getPropertyDistance, getPropertyLocation} from "../../helpers/quick_view/set_property_info";

interface IProps {
    address: string;
    offerType: number;
    distanceFromRegion?: {
        center: boolean;
        region: string;
        distance: number;
    };
    className?: string;
    textVariant?: TextVariantUnionType;
}

export const QWLocalizationInfo = (props: IProps) => {
    const {offerType, address, distanceFromRegion} = props;

    const theme = useTheme();
    return (
        <div css={localizationInfo} className={props.className}>
            <div css={flex("flex-start")}>
                <MapMarkerOutlineIcon css={mr(1)} size="2.4" fill={theme.colors.gray[700]} />

                <Text as="div" variant={props.textVariant || "info_txt_2"} mb="1.6rem">
                    <span>{getPropertyLocation(offerType, address)}</span>
                </Text>
            </div>
            {distanceFromRegion && (
                <div css={flex("flex-start")}>
                    <CityIcon css={mr(2)} size="2.4" fill={theme.colors.gray[700]} />

                    <Text as="div" variant={props.textVariant || "info_txt_2"} mb="1.6rem">
                        <span>{getPropertyDistance(distanceFromRegion)}</span>
                    </Text>
                </div>
            )}
        </div>
    );
};
const localizationInfo = (theme: Theme) => css`
    color: ${theme.colors.gray[700]};
    padding-left: 0.6rem;
    ${flex("flex-start")};
    ${flexDirection("column")};
`;
